<template>
    <div>
        <news-base-header-sec></news-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" @reset="onReset">

                    <div class="form-group form-group-sm">
                        <label for="titleQuery" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="titleQuery" v-model="form.titleQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.titleMustOccur" class="mr-2" id="titleMustOccur">
                                    <label class="in-btn-form-label" for="titleMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="bodyQuery" class="form-label"> Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="bodyQuery" v-model="form.bodyQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.bodyMustOccur" class="mr-2" id="bodyMustOccur">
                                    <label class="in-btn-form-label" for="bodyMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-lg-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Категорија вести</label>
                                <b-form-select v-model="form.newsCatId" class="form-control full-width">
                                    <option label="Све" value="-1">Све</option>
                                    <option v-for="option in newsCategoryOptions" v-bind:key="option.val"
                                        :value="option.val">
                                        {{ option.name }}
                                    </option>
                                </b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-12 col-lg-8">
                            <data-picker-mask-horizontal-component ref="dataPickerMask"
                                @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-horizontal-component>

                        </div>
                        <!--                        <div class="col-md-12 col-lg-4">-->
                        <!--                            <b-form-group class="form-group-sm">-->
                        <!--                                <input-->
                        <!--                                        id="maskedDateFrom_input"-->
                        <!--                                        class="form-control full-width masked_date_input_1 form-control"-->
                        <!--                                        type="text"-->
                        <!--                                        @keyup="maskedDateFromHandler"-->
                        <!--                                        v-model="maskedDateFrom"-->
                        <!--                                        v-mask="{mask: '99.99.9999', greedy: false}">-->
                        <!--                                <label class="form-label">Датум од</label>-->
                        <!--                                &lt;!&ndash;                                @selected=""&ndash;&gt;-->
                        <!--                                <datepicker-->

                        <!--                                        id="date_pick_1"-->
                        <!--                                        :typeable="true"-->
                        <!--                                        :disabledDates="disabledDatesFrom"-->
                        <!--                                        :full-month-name="true"-->
                        <!--                                        format="dd.MM.yyyy"-->
                        <!--                                        v-model="form.dateFrom"-->
                        <!--                                        input-class="form-control full-width date_input_1"-->
                        <!--                                        :calendar-button="true"-->
                        <!--                                        calendar-button-icon="icon-calendar1"-->
                        <!--                                        :clear-button="true"-->
                        <!--                                        clear-button-icon="icon-x"-->
                        <!--                                        :bootstrap-styling="true"-->
                        <!--                                        :language="srCYRL">-->
                        <!--                                </datepicker>-->
                        <!--                            </b-form-group>-->
                        <!--                        </div>-->
                        <!--                        <div class="col-md-12 col-lg-4">-->
                        <!--                            <b-form-group class="form-group-sm">-->
                        <!--                                <label class="form-label">Датум до</label>-->
                        <!--                                <input-->
                        <!--                                        id="maskedDateTo_input"-->
                        <!--                                        class="form-control full-width masked_date_input_1 form-control"-->
                        <!--                                        type="text"-->
                        <!--                                        @keyup="maskedDateToHandler"-->
                        <!--                                        v-model="maskedDateTo"-->
                        <!--                                        v-mask="{mask: '99.99.9999', greedy: false}">-->

                        <!--                                <datepicker-->
                        <!--                                        id="date_pick_2"-->
                        <!--                                        :disabledDates="disabledDatesTo"-->
                        <!--                                        :full-month-name="true"-->
                        <!--                                        format="dd.MM.yyyy"-->
                        <!--                                        v-model="form.dateTo"-->
                        <!--                                        input-class="form-control full-width date_input_1"-->
                        <!--                                        :calendar-button="true"-->
                        <!--                                        calendar-button-icon="icon-calendar1"-->
                        <!--                                        :clear-button="true"-->
                        <!--                                        clear-button-icon="icon-x"-->
                        <!--                                        :bootstrap-styling="true"-->
                        <!--                                        :language="srCYRL">-->
                        <!--                                </datepicker>-->
                        <!--                            </b-form-group>-->
                        <!--                        </div>-->
                    </div>


                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="form.resultLimit" class="form-control">
                                    <option v-for="option in resultLimitOptions" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3" :disabled="!validvalue">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter v-if="searchResult && searchResult[0]" :count="searchResult[0].returnedCollectionSize"
                :limit="form.resultLimit"></result-counter>

            <result-counter v-if="searchResult && searchResult.length === 0" :count="0"
                :limit="form.resultLimit"></result-counter>


            <div v-if="searchResult && searchResult[0]" class="base-box base-box__table-sec">
                <b-table class="table-bootstrap-vue" striped bordered :items="searchResult" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(newsPublishedDateTime)="data">
                        {{ moment(data.item.newsPublishedDateTime).format('DD.MM.YYYY') }}
                    </template>
                    <template v-slot:cell(newsShortText)="data">
                        <a @click.prevent='openModal(data.item.newsShortText, data.item.newsHtmlUuid, data.item.newsId, data.item.newsFullText)'
                            href="#">
                            {{ data.item.newsShortText }}
                        </a>

                    </template>
                </b-table>
            </div>
        </div>

        <news-single-modal id="searchNewsModal" :title="modalTitle" :iframeUrl="modalIframeUrl"
            :fullText="fullText" :close="closeModal"></news-single-modal>

    </div>
</template>


<script>
import moment from 'moment';
import axios from 'axios';
import NewsBaseHeaderSec from '@/components/NewsBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';

// import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css';

import { srCYRL } from 'vuejs-datepicker/dist/locale'
import DataPickerMaskHorizontalComponent from '@/components/DataPickerMaskHorizontalComponent';
// import {SortedTable, SortLink} from "vue-sorted-table";
import NewsSingleModal from '@/components/NewsSingleModal.vue';
import ResultCounter from '@/partials/ResultCounter.vue';


export default {
    name: "NewsSearchPage",
    data() {
        return {
            sortBy: 'newsPublishedDateTime',
            sortDesc: true,
            fields: [
                { label: 'Датум', key: 'newsPublishedDateTime', sortable: true },
                { label: 'Категорија вести', key: 'categoryName', sortable: true },
                { label: 'Наслов', key: 'newsShortText', sortable: true },
            ],
            maskedDateFrom: null,
            maskedDateTo: null,
            form: {
                dateFrom: null,
                dateTo: null,
                newsCatId: -1,
                titleQuery: null,
                titleMustOccur: true,
                bodyQuery: null,
                bodyMustOccur: true,
                resultLimit: 50,
            },

            newsCategoryOptions: [
                { val: 1, name: 'Службени гласник' },
                { val: 2, name: 'Активности државних органа' },
                { val: 3, name: 'Активности у правосуђу' },
                { val: 4, name: 'Остало' },
            ],
            resultLimitOptions: [50, 100, 200, 300, 400, 500],
            searchResult: null,
            searchFilter: null,
            srCYRL: srCYRL,

            // Modal
            modalTitle: null,
            modalIframeUrl: null,
            fullText: '',

            fpApiUrl: window.env.VUE_APP_API_FP_DEV,
            diApiUrl: window.env.VUE_APP_API_DI_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        NewsBaseHeaderSec,
        // Datepicker,
        // DatePicker,
        // SortedTable,
        // SortLink,
        NewsSingleModal,
        ResultCounter,
        DataPickerMaskHorizontalComponent
    },
    computed: {
        // maskedDateFrom  () {
        //     // if (this.form.dateFrom) {
        //     //     return moment(this.form.dateFrom).format('DD.MM.YYYY')
        //     // } else {
        //     //     return null
        //     // }
        //
        //
        // },
        datefrom() {
            if (this.form.dateFrom) {
                return moment(this.form.dateFrom).format('YYYYMMDD') + '000000';
            } else {
                return null
            }
        },
        dateto() {
            if (this.form.dateTo) {
                return moment(this.form.dateTo).format('YYYYMMDD') + '235959';
            } else {
                return null
            }
        },
        category() {
            if (this.form.newsCatId === -1) {
                return null;
            } else {
                return this.form.newsCatId
            }
        },
        disabledDatesFrom: function () {
            if (this.form.dateTo === null) {
                return { from: new Date }
            } else return { from: this.form.dateTo }
        },
        disabledDatesTo: function () {
            if (this.form.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.form.dateFrom, from: new Date }
        },
        validvalue: function () {
            return true;
        }


    },
    watch: {
        'form.dateFrom': function () {
            this.maskedDateFrom = moment(this.form.dateFrom, 'YYYY-MM-DD').format('DD.MM.YYYY');
        },
        'form.dateTo': function () {
            this.maskedDateTo = moment(this.form.dateTo, 'YYYY-MM-DD').format('DD.MM.YYYY');
        }
        // maskedDateFrom(){
        //     // this.form.dateFrom =   this.maskedDateFrom
        // },
    },
    methods: {

        emitedDateFrom(e) {
            if (e) {
                this.form.dateFrom = new Date(e);
            } else {
                this.form.dateFrom = null
            }
        },
        emitedDateTo(e) {
            if (e) {
                this.form.dateTo = new Date(e);
            } else {
                this.form.dateTo = null
            }
        },
        maskedDateFromHandler() {
            if (!this.maskedDateFrom.includes("_")) {
                this.form.dateFrom = moment(this.maskedDateFrom, 'DD.MM.YYYY').format('YYYY-MM-DD');
            }
        },
        maskedDateToHandler() {
            if (!this.maskedDateTo.includes("_")) {
                this.form.dateTo = moment(this.maskedDateTo, 'DD.MM.YYYY').format('YYYY-MM-DD')
            }
        },
        customFormatter(date) {
            return moment(date).format('dd.MM.yyyy');
        },
        openModal(title, uuid, id, fullText) {

            // console.log(title);
            if (uuid) {
                this.modalIframeUrl = this.fpApiUrl + 'prins/GetDocTypeHtml?uuid=' + uuid + '&id=' + id + '&doctype=fpnews';
                this.fullText = '';
            }
            else {
                this.fullText = fullText;
                this.modalIframeUrl = null;
            }
            this.modalTitle = title;
            this.$bvModal.show('searchNewsModal');
        },
        closeModal() {
            this.modalIframeUrl = null;
            this.fullText = '';
        },
        onSubmit(evt) {
            evt.preventDefault();

            axios.get(this.diApiUrl + 'FP/FilterNews', {
                params: {
                    //http://pravno-informacioni-sistem.rs/SlGlasnikPortal/api/fp/news/searchall?limit=50&contentmust=true&titlemust=true
                    limit: this.form.resultLimit,
                    category: this.category,
                    content: this.form.bodyQuery,
                    contentmust: this.form.bodyMustOccur,
                    title: this.form.titleQuery,
                    titlemust: this.form.titleMustOccur,
                    datefrom: this.datefrom,
                    dateto: this.dateto,
                }

            }).then(response => {
                // console.log(response.data);

                this.searchResult = [];
                for (var i = 0; i < response.data.length; i++) {

                    // console.log(response.data[i].returnedCollectionSize);
                    this.searchResult[i] = {
                        returnedCollectionSize: response.data[i].returnedCollectionSize,
                        newsPublishedDateTime: response.data[i].newsPublishedDateTime,
                        newsShortText: response.data[i].fpDocumentInfo.newsShortText,
                        categoryName: response.data[i].fpDocumentInfo.categoryName,
                        newsHtmlUuid: response.data[i].fpDocumentInfo.newsHtmlUuid,
                        newsId: response.data[i].fpDocumentInfo.newsId,
                        newsBreaking: response.data[i].fpDocumentInfo.newsBreaking,
                        newsDirectLink: response.data[i].fpDocumentInfo.newsDirectLink,
                        newsFullText: response.data[i].fpDocumentInfo.newsFullText

                    };
                }
                // this.searchResult = response.data;
                this.values = this.searchResult;
                // console.log("values : ", this.values);
            }).catch(function (error) {
                console.log(error);
            });


        },
        onReset(evt) {
            console.log("evnt", this.$refs.dataPickerMask);
            this.$refs.dataPickerMask.maskedDateTo = "";
            this.$refs.dataPickerMask.maskedDateFrom = "";
            // this.emitedDateTo
            // var text = document.getElementById('text');
            // var button = document.getElementById('button');
            // button.onclick = function() {
            //     text.value = '';
            // }
            evt.preventDefault();
            this.form.dateFrom = null;
            this.form.dateTo = "";
            this.form.newsCatId = -1;
            this.form.titleQuery = null;
            this.form.titleMustOccur = true;
            this.form.bodyQuery = null;
            this.form.bodyMustOccur = true;
            this.form.resultLimit = 50;
            this.searchResult = null;
            this.$refs.dataPickerMask.resetDate();
        },
    },
    mounted() {

        // maskedDateFrom_input
        let date_pick_1 = document.getElementById('date_pick_1');
        let maskedDateFrom_input = document.getElementById('maskedDateFrom_input');
        date_pick_1.inputmask = maskedDateFrom_input.inputmask;
        date_pick_1.parentNode.append(maskedDateFrom_input);

        // maskedDateTo_input
        // date_pick_2
        let date_pick_2 = document.getElementById('date_pick_2');
        let maskedDateTo_input = document.getElementById('maskedDateTo_input');
        date_pick_2.inputmask = maskedDateTo_input.inputmask;
        date_pick_2.parentNode.append(maskedDateTo_input);

    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style>
.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}

.date_input_1 {
    display: none;
}
</style>
